
export class Endereco{
    streetName: string;
    number: string;
    complement: string;
    district: string;
    cityID: string;
    stateID: string;
    zipCode: string;
}